import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import InputDate from './InputDate';
import consts from '../libs/consts';

import Radios from './Radios';
import Checkbox from './Checkbox';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import DaumPostcode from 'react-daum-postcode';
import { getBase64, getBase64toDataUrl, getMemberinfo } from '../utils/utils';
import InfoViewlists from './InfoViewlists';
import * as APIS from "../utils/service";
import DatePicker from "react-datepicker";
import ContractwriterPage1 from './ContractwriterPage1';
import ContractwriterPage2 from './ContractwriterPage2';
import ContractwriterPage3 from './ContractwriterPage3';


export default function Contractwrite(props) {

    const {
        setdetailwrite = () => { },
        contractIdx = null,
        setupdatestatus = () => { },
        memberinfos = {},
        productrow = {},
        zIndexs = 1000
    } = props;
    const { configdata } = useSelector(s => s.configReducer);
    let wheight = window.innerHeight;

    const popscrolldiv = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isOpenPost, setIsOpenPost] = useState(false);
    const [viewpages, setviewpages] = useState(0);
    const [addrDatas, setaddrDatas] = useState({});
    const [conIdx, setconIdx] = useState(contractIdx);
    const [categorys, setcategorys] = useState('집합건물');
    const [subcategorys, setsubcategorys] = useState('주거용');
    const [row, setrow] = useState(null);
    const [productinfoArr, setproductinfoArr] = useState([
        { key: 'area_supply', requireCkr: true, inputstyle: 1, titles: '공급면적', values: '', input_type: 'text', viewtype: [1, 2, 3] },
    ]);

    const [p_code, setp_code] = useState('');
    const [pcodeDatas, setpcodeDatas] = useState([]);
    const [list1Viewer, setlist1Viewer] = useState(0);
    const [list2Viewer, setlist2Viewer] = useState(0);
    const [list3Viewer, setlist3Viewer] = useState(0);
    const [list4Viewer, setlist4Viewer] = useState(0);
    const [list5Viewer, setlist5Viewer] = useState(0);
    const [list6Viewer, setlist6Viewer] = useState(0);
    const [list7Viewer, setlist7Viewer] = useState(0);
    const [list8Viewer, setlist8Viewer] = useState(0);
    const [pcodesubDatas, setpcodesubDatas] = useState([]);
    const [listdongNames, setlistdongNames] = useState('');


    useEffect(() => {
        console.log(memberinfos);
        dispatch(loadingflas({ loading: false }));
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);

    // useEffect(() => {
    //     if(row?.idx){

    //     }
    // }, [row]);


    useEffect(() => {
        console.log('????', contractIdx);
        getRows();
    }, [conIdx, contractIdx]);
    const scrolTopFunc = () => {
        if (popscrolldiv !== null) {
            popscrolldiv.current.scrollTop = 0;
        }
    }
    const onCompletePost = (data) => {
        let fullAddr = data.address;
        let extraAddr = '';

        //console.log('data', data);

        //let jibunAddress = jibunAddress;

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddr += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddr += extraAddr !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddr += extraAddr !== '' ? ` (${extraAddr})` : '';
        }
        //console.log(data);

        setaddrDatas({
            addr: data.address,
            sido: data?.sido,
            sigungu: data?.sigungu || data?.sido,
            dong: data?.bname1 || data?.bname
        });

        setIsOpenPost(false);
    };
    const postBoxStyle = {
        display: 'block',
        position: 'relative',
        width: '100%',
        border: '1px solid #000',
        marginTop: 5,
        textAlign: 'right'
    };
    const postCodeStyle = {
        width: '100%',
        borderTop: '1px solid #000',
    };

    const getRows = (reload = false) => {
        if (conIdx * 1 > 0) {
            let sender = { idx: conIdx }
            console.log("senders", sender);
            APIS.postData('/v1/contract/get', sender).then(({ data }) => {
                if (data) {
                    console.log("?????????", data);
                    setrow(data);
                    setconIdx(data?.idx);
                    setp_code(data?.p_code);
                    setcategorys(data?.category);
                    setsubcategorys(data?.sub_category);
                }
            }).catch(({ response }) => {
                const { data } = response;
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });
        }
    }
    const contractWirteSubmit = (uidx = null, sell_type, category, mediation_option, contract, sub_category, nopop = false) => {
        let sender = {
            idx: uidx,
            sell_type: sell_type,
            category: category,
            sub_category: sub_category,
            p_code: p_code,
            mediation_option: mediation_option,
            contract: JSON.stringify(contract),
        }

        APIS.postData('/v1/contract/insert', sender).then(({ data }) => {
            if (data) {
                console.log(data);
                //setrow(data);
                if (data * 1 > 0 && nopop === false) {
                    setconIdx(data);
                    getRows();
                    dispatch(listupdater({ listupdate: true }));
                    dispatch(
                        open({
                            component: `계약이 ${uidx !== null ? '수정' : '등록'}이 완료되었습니다.${uidx !== null ? '\n거래 당사자의 주민등록번호는 저장되지 않으므로 계약 당일 다시한번 확인 및 작성하시기 바랍니다.' : '\n거래 당사자의 주민등록번호는 저장되지 않으므로 계약 당일 다시한번 확인 및 작성하시기 바랍니다.'}`,
                            title: '알림',
                            titleviewer: true,
                            alert: false,
                            button: "확인",
                            onPress: () => {
                                dispatch(close());
                            }
                        })
                    );
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
            dispatch(
                open({
                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                    title: '알림',
                    button: "확인",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );

        }).finally(() => {
            if (nopop === false) {
                dispatch(loadingflas({ loading: false }));
            }
        });
    }
    const contractconfirmWirteSubmit = (uidx = null, contract, nopop = false) => {
        let sender = {
            idx: uidx,
            confirmation: JSON.stringify(contract),
        }
        APIS.postData('/v1/contract/confirmationUpdate', sender).then(({ data }) => {
            if (data) {
                console.log(data);
                //setrow(data);
                if (data * 1 > 0 && nopop === false) {
                    //setconIdx(data);
                    getRows();
                    dispatch(
                        open({
                            component: `확인서가 ${uidx !== null ? '수정' : '등록'}되었습니다.`,
                            title: '알림',
                            titleviewer: true,
                            alert: false,
                            button: "확인",
                            onPress: () => {
                                dispatch(close());
                            }
                        })
                    );
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                    title: '알림',
                    button: "확인",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    useEffect(() => {
        if (p_code !== '') {
            let sender = {
                code: p_code
            }
            APIS.postData('/v1/item/getData', sender).then(({ data }) => {
                if (data) {
                    //console.log("?????????", data);
                    let searchlist = data['부속지번'];
                    //console.log(searchlist);
                    let subpcodeData = [];
                    searchlist?.map((x, i) => {
                        //console.log(x);
                        let pcodes = `${x['부속시군구코드']}${x['부속법정동코드']}${(x['부속대지구분코드'] * 1 === 0 ? 1 : x['부속대지구분코드'] * 1 === 1 ? 2 : x['부속대지구분코드'] * 1)}${x['부속번']}${x['부속지']}`;
                        subpcodeData.push(pcodes);
                    });

                    sender = {
                        code: subpcodeData
                    }
                    APIS.postData('/v1/item/getDatasub', sender).then(({ data }) => {
                        if (data) {
                            //console.log("?????????", data);
                            //subpcodeData.push(data);
                            setpcodesubDatas(data);
                        }
                    }).catch(({ response }) => {
                        //console.log(data);
                    }).finally(() => {
                        dispatch(loadingflas({ loading: false }));
                    });

                    //console.log(subpcodeData);
                    //console.log(subpcodeData);
                    let selectlists = data['표제부']?.map((x, i) => {
                        return { labels: `${x['동명'] || ''}`, values: i }
                    });
                    console.log(selectlists[0]?.labels);
                    setlistdongNames(selectlists[0]?.labels || '');

                    setpcodeDatas(data);
                }
            }).catch(({ response }) => {
                const { data } = response;
                console.log(data);
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });
        }
    }, [p_code]);

    return (
        <>

            <div className='ProductDetailArea' style={{ zIndex: zIndexs }}>
                <div ref={popscrolldiv} style={{ gap: 30 }}>
                    <div className='ProductDetailAreaBG'
                    // onClick={() => {
                    //     setdetailwrite(false);
                    // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop2 " style={{ width: 1140 }}>
                        <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee' }}>
                            <span>계약서 작성</span>
                            <button
                                onClick={() => {
                                    setdetailwrite(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />
                            </button>
                        </div>
                        <div className='doubleArea' >
                            <div className="productInputarea padding32" style={{ height: wheight - 130, overflow: 'auto', borderRight: '1px solid #ddd' }}>
                                {viewpages === 0 && <ContractwriterPage1
                                    setviewpages={setviewpages} scrolTopFunc={scrolTopFunc} setdetailwrite={setdetailwrite} row={row}
                                    contractWirteSubmit={contractWirteSubmit}
                                    setp_code={setp_code}
                                    setlist1Viewer={setlist1Viewer}
                                    setlist2Viewer={setlist2Viewer}
                                    setpcodeDatas={setpcodeDatas}
                                    memberinfos={memberinfos}
                                    productrow={productrow}
                                />}
                                {viewpages === 1 && subcategorys === '주거용' && memberinfos && <ContractwriterPage2
                                    setviewpages={setviewpages} scrolTopFunc={scrolTopFunc} row={row}
                                    contractWirteSubmit={contractconfirmWirteSubmit}
                                    memberinfos={memberinfos}
                                />}
                                {viewpages === 1 && subcategorys === '비주거용' && memberinfos && <ContractwriterPage3
                                    setviewpages={setviewpages} scrolTopFunc={scrolTopFunc} row={row}
                                    contractWirteSubmit={contractconfirmWirteSubmit}
                                    memberinfos={memberinfos}
                                />}
                            </div>
                            {p_code !== '' ?
                                <div
                                    style={{
                                        display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', gap: 8,
                                        height: wheight - 130, overflow: 'auto'
                                    }}
                                >
                                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                                        <Button
                                            buttonTxt={'인터넷등기소'}
                                            className={'linenormalbutton'}
                                            onPress={() => {
                                                window.open("https://www.iros.go.kr/index.jsp")
                                            }}
                                            styles={{
                                                fontSize: 14, width: 120, height: 36
                                            }}
                                        />
                                        <Button
                                            buttonTxt={'세움터'}
                                            className={'linenormalbutton'}
                                            onPress={() => {
                                                window.open("https://www.eais.go.kr/")
                                            }}
                                            styles={{
                                                fontSize: 14, width: 120, height: 36
                                            }}
                                        />
                                        <Button
                                            buttonTxt={'정부24'}
                                            className={'linenormalbutton'}
                                            onPress={() => {
                                                window.open("https://www.gov.kr/")
                                            }}
                                            styles={{
                                                fontSize: 14, width: 120, height: 36
                                            }}
                                        />
                                        {pcodeDatas['토지이용계획']?.length > 0 && <Button
                                            buttonTxt={'토지이음'}
                                            className={'linenormalbutton'}
                                            onPress={() => {
                                                let code = pcodeDatas['토지이용계획'][0]['식별코드']
                                                window.open(`http://www.eum.go.kr/web/ar/lu/luLandDet.jsp?pnu=${code}&isNoScr=script&chk=0&mode=search`)
                                            }}
                                            styles={{
                                                fontSize: 14, width: 120, height: 36
                                            }}
                                        />}
                                    </div>
                                    {pcodeDatas['총괄표제부']?.filter((item, index) => index === list1Viewer).map((x, i) => {
                                        return (
                                            <InfoViewlists
                                                p_code={p_code}
                                                titles={'총괄표제부'}
                                                rightButtons={pcodeDatas['총괄표제부']?.length > 1 ? true : false}
                                                rightButtonsCount={pcodeDatas['총괄표제부']}
                                                setrightButtons={setlist1Viewer}
                                                lists={[
                                                    { viewnames: '건물명', values: x['건물명'] || '-' },
                                                    { viewnames: '용도', values: x['기타용도'] || '-' },
                                                    { viewnames: '대지면적', values: x['대지면적'] + '㎡' || '-' },
                                                    { viewnames: '건축면적', values: x['건축면적'] + '㎡' || '-' },
                                                    { viewnames: '연면적', values: x['연면적'] + '㎡' || '-' },
                                                    { viewnames: '건폐율', values: x['건폐율'] || '-' },
                                                    { viewnames: '용적률', values: x['용적률'] || '-' },
                                                    { viewnames: '세대/가구/호', values: `${x['세대수']}/${x['가구수']}/${x['호수']}` },
                                                    { viewnames: '외필지수', values: x['외필지수'] || '-' },
                                                    { viewnames: '기계식 주차', values: `${((x['옥내기계식대수'] * 1) + (x['옥외기계식대수'] * 1))}` },
                                                    { viewnames: '자주식 주차', values: `${((x['옥내자주식대수'] * 1) + (x['옥외자주식대수'] * 1))}` },
                                                    { viewnames: '승강기(승용)', values: x['승용승강기수'] || '-' },
                                                    { viewnames: '승강기(비상)', values: x['비상용승강기수'] || '-' },
                                                    { viewnames: '사용승인일', values: moment(x['사용승인일']).format('YYYY-MM-DD') || '-' },
                                                ]}
                                            />
                                        );
                                    })}
                                    {pcodeDatas['표제부']?.filter((item, index) => index === list2Viewer).map((x, i) => {
                                        return (
                                            <InfoViewlists
                                                p_code={p_code}
                                                titles={'표제부'}
                                                rightButtons={pcodeDatas['표제부']?.length > 1 ? true : false}
                                                rightButtonsCount={pcodeDatas['표제부']}
                                                setrightButtons={setlist2Viewer}
                                                setlistdongNames={setlistdongNames}
                                                lists={[
                                                    { viewnames: '건물명', values: x['건물명'] || '-' },
                                                    { viewnames: '동', values: x['동명'] || '-' },
                                                    { viewnames: '주용도', values: x['기타용도'] || '-' },
                                                    { viewnames: '주구조', values: x['기타구조'] || '-' },
                                                    { viewnames: '층수(지상/지하)', values: `${x['지상층수']}/${x['지하층수']}}` },
                                                    { viewnames: '대지면적', values: x['대지면적'] + '㎡' || '-' },
                                                    { viewnames: '건축면적', values: x['건축면적'] + '㎡' || '-' },
                                                    { viewnames: '연면적', values: x['연면적'] + '㎡' || '-' },
                                                    { viewnames: '건폐율', values: x['건폐율'] || '-' },
                                                    { viewnames: '용적률', values: x['용적률'] || '-' },
                                                    { viewnames: '세대/가구/호', values: `${x['세대수']}/${x['가구수']}/${x['호수']}` },
                                                    { viewnames: '외필지수', values: x['외필지수'] || '-' },
                                                    { viewnames: '기계식 주차', values: `${((x['옥내기계식대수'] * 1) + (x['옥외기계식대수'] * 1))}` },
                                                    { viewnames: '자주식 주차', values: `${((x['옥내자주식대수'] * 1) + (x['옥외자주식대수'] * 1))}` },
                                                    { viewnames: '승강기(승용)', values: x['승용승강기수'] || '-' },
                                                    { viewnames: '승강기(비상)', values: x['비상용승강기수'] || '-' },
                                                    { viewnames: '사용승인일', values: moment(x['사용승인일']).format('YYYY-MM-DD') || '-' },
                                                ]}
                                            />
                                        );
                                    })}
                                    {pcodeDatas['표제부']?.find((item, index) => index === list2Viewer)?.['대장종류코드명'] === '일반건축물' &&
                                        <InfoViewlists
                                            p_code={p_code}
                                            titles={'층별개요'}
                                            listdongNames={listdongNames}
                                            lists={listdongNames ? pcodeDatas['층별개요']?.filter(item => item['동명'] === listdongNames).map((x, i) => {
                                                x.viewnames = `${x['층구분코드명']} ${x['층번호']}층`;
                                                x.values = x['기타용도'];
                                                x.values1 = `${x['면적']}㎡`;
                                                return x;
                                            }) : pcodeDatas['층별개요']?.map((x, i) => {
                                                x.viewnames = `${x['층구분코드명']} ${x['층번호']}층`;
                                                x.values = x['기타용도'];
                                                x.values1 = `${x['면적']}㎡`;
                                                return x;
                                            })}
                                        />
                                    }
                                    {pcodeDatas['표제부']?.find((item, index) => index === list2Viewer)?.['대장종류코드명'] === '표제부' &&
                                        <InfoViewlists
                                            styles={'infoviewstyle2'}
                                            titles={'호실정보'}
                                            liststyle2arr={pcodeDatas['전유공용']}
                                            lists={[
                                                { viewnames: '전유', values: '3층', values1: '제1종근린시설', values2: '(치과의원)', values3: '1,383.19 ㎡' },
                                                { viewnames: '공용', values: '지1층', values1: '게계실, 발전기실, 전기실', values2: '', values3: '1.05 ㎡' },
                                                { viewnames: '공용', values: '3층', values1: '복도, 화장실, 계단실, 엘리베이터', values2: '', values3: '30.96 ㎡' },
                                                { viewnames: '공용', values: '틍각층', values1: '주차장', values2: '(지하1층, 1층)', values3: '48.86 ㎡' },
                                            ]}
                                        />
                                    }

                                    {/* {pcodeDatas['토지이용계획']?.map((x, i) => {
                                    //console.log(pcodeDatas['토지이용계획']);
                                    //console.log(pcodeDatas['토지임야정보']);
                                })} */}
                                    {pcodeDatas['토지이용계획']?.length > 0 &&
                                        <InfoViewlists
                                            titles={'토지이용계획(본)'}
                                            styles={'infoviewstyle3'}
                                            lists={{
                                                title: pcodeDatas['토지임야정보'],
                                                sublists: pcodeDatas['토지이용계획'],
                                            }}
                                        />
                                    }
                                    {pcodesubDatas?.length > 0 && pcodesubDatas?.map((x, i) => {
                                        //console.log("!!!!!!!!!!", x['토지임야정보']?.length);
                                        if (x['토지임야정보']?.length > 0) {
                                            return (
                                                <InfoViewlists
                                                    titles={'토지이용계획(부)'}
                                                    styles={'infoviewstyle3'}
                                                    lists={{
                                                        title: x['토지임야정보'],
                                                        sublists: x['토지이용계획'],
                                                    }}
                                                />
                                            );
                                        }
                                    })}
                                </div>
                                :
                                <div>
                                    <div className='nolistArea'>
                                        소재지를 검색해주세요.
                                    </div>
                                </div>}
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )
}